// extracted by mini-css-extract-plugin
export default {"btn-signUp":"Sign-Up_btn-signUp__sYAEj","button24":"Sign-Up_button24__otJpZ"};